import { render } from "./NewsfeedStatistics.vue?vue&type=template&id=2174a1c1&scoped=true"
import script from "./NewsfeedStatistics.vue?vue&type=script&lang=js"
export * from "./NewsfeedStatistics.vue?vue&type=script&lang=js"

import "./NewsfeedStatistics.vue?vue&type=style&index=0&id=2174a1c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2174a1c1"]])

export default __exports__